export const HomeSceneTranslation = {
  fi: {
    HomeScene: {
      title: 'Älylääkekaapit',
      name: 'Nimi:',
      active: 'Aktiivinen:',
      offline: 'Offline',
      loading: 'Lataa',
      empty: 'Sinulla ei ole yhtään älylääkekaappia',
      now: 'Aktiivinen',
    },
  },
};
